import {AuthenticationService} from "../services/authentication.service";
import {OnInit} from "@angular/core";
import {MatSnackBar} from "@angular/material";
/**
 * Created by lk on 11/7/2018.
 */
export abstract class BaseComponent implements OnInit {
  abstract myNgOnInit();

  constructor(public snackBar: MatSnackBar, protected _service: AuthenticationService) {
  }

  ngOnInit(): any {
    if (!this._service.checkCredentials()) {
      console.log("return");
      return;
    }
    this.myNgOnInit();
  }

  openSnackBar(text) {
    this.snackBar.open(text, null, {duration: 2000, verticalPosition: 'top'});
  }
}
